import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { DashboardServiceInterface } from './dashboard.service.interface';
import { DPSitePage } from 'src/app/core/models/enums/DPSitePage';
import { take, switchMap, map, Observable } from 'rxjs';
import { CompanyService } from 'src/app/core/services/company.service';
import { DPUserStatus } from 'src/app/core/models/enums/DPUserStatus';
import { DPCompany } from 'src/app/core/models/DPCompany';

@Injectable({
  providedIn: 'root',
})
export class DashboardService implements DashboardServiceInterface {
  constructor(
    private api: ApiService,
    private auth: AuthService,
    private company: CompanyService
  ) {}

  public getCompliance(force?: boolean) {
    return this.api.getCompliance(this.auth.getUserInfo(), {
      force,
      alias: ['complianceInfo'],
    });
  }

  public getNextStepsDescription(force?: boolean): Observable<string> {
    const text$ = this.company.getJobs(force).pipe(
      switchMap((jobs) => {
        const completedJob = jobs.find(
          (job) => job.userStatusID === DPUserStatus.Completed
        );
        return this.api.getCustomText(
          this.auth.companySettingID,
          DPSitePage.JobComplete,
          completedJob?.jobID || null,
          { force }
        );
      }),
      switchMap((text) =>
        this.company.info.pipe(
          take(1),
          map((info) => text.replace(/\{CompanyName\}/g, info.companyName))
        )
      ),
      take(1)
    );

    return text$;
  }
}
